import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  ButtonComponent,
  FormSectionComponent,
  CheckboxFieldWithErrorComponent
} from 'htx-ui-library';
import { MatDialog } from '@angular/material/dialog';
import {
  PdfViewerDialogComponent,
  PdfViewerDialogData
} from '../../../organisms/pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'app-registration-step-0-preface',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    ButtonComponent,
    FormSectionComponent,
    CheckboxFieldWithErrorComponent
  ],
  templateUrl: './registration-step-0-preface.component.html',
  styleUrl: './registration-step-0-preface.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistrationStep0PrefaceComponent {
  readonly prefaceForm = input.required<FormGroup>();

  private dialog = inject(MatDialog);

  openPdf(url: string): void {
    const data: PdfViewerDialogData = {
      url
    };

    this.dialog.open(PdfViewerDialogComponent, {
      data,
      width: '80vw',
      maxWidth: '95vw',
      height: '90vh',
      autoFocus: false,
      panelClass: 'pdf-viewer-dialog'
    });
  }
}
